import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import BranchLogin from "@/pages/branch/login/page";
import BranchLayout from "@/pages/branch/layout";
import OrdersPage from "@/pages/branch/orders/page";
import PosPage from "@/pages/branch/pos/page";
import PosSuccessPage from "@/pages/branch/pos/success/page";
import MenuPage from "@/pages/branch/menu/page";
import SettingsPage from "@/pages/branch/settings/page";
import DashboardPage from "@/pages/branch/dashboard/page";
import ReportsPage from "@/pages/branch/reports/page";
import NotificationsPage from "@/pages/branch/notifications/page";
import AccountPage from "@/pages/branch/account/page";
import ChangePhonePage from "@/pages/branch/account/change-phone/page";
import NoPermissionsPage from "@/pages/branch/no-permissions/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <BranchLogin />,
  },
  {
    path: "/login",
    element: <BranchLogin />,
  },
  {
    element: <BranchLayout />,
    children: [
      {
        path: "dashboard",
        element: <DashboardPage />,
      },
      {
        path: "orders",
        element: <OrdersPage />,
      },
      {
        path: "pos",
        element: <PosPage />,
      },
      {
        path: "pos/success/:id",
        element: <PosSuccessPage />,
      },
      {
        path: "menu",
        element: <MenuPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "reports",
        element: <ReportsPage />,
      },
      {
        path: "notifications",
        element: <NotificationsPage />,
      },
      {
        path: "account",
        element: <AccountPage />,
      },
      {
        path: "account/change-phone",
        element: <ChangePhonePage />,
      },
      {
        path: "no-permissions",
        element: <NoPermissionsPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;